import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Btn, Field, Overline, Card } from "@/components/kit";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "@/components/ui/sonner";

export default function ChangePassword() {
  const { user, changePassword } = useAuth();
  const navigate = useNavigate();
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const forced = user?.must_change_password;

  const submit = async (e) => {
    e.preventDefault();
    if (!current || !next || !confirm) return toast.error("Please fill in all fields.");
    if (next.length < 10) return toast.error("New password must be at least 10 characters.");
    if (next !== confirm) return toast.error("New passwords do not match.");
    if (next === current) return toast.error("New password must be different from your current password.");
    setLoading(true);
    try {
      await changePassword(current, next);
      toast.success("Password updated. Other devices have been signed out.");
      navigate("/");
    } catch (err) {
      toast.error(apiError(err, "Unable to change password."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-lg mx-auto em-fade-up">
      <Overline>Account security</Overline>
      <h1 className="font-serif text-4xl text-ink mt-2">Change password</h1>
      <p className="text-inkfaint mt-2 mb-8">
        {forced
          ? "Welcome. For your security, please choose a new password before you continue."
          : "Enter your current password and choose a new one (at least 10 characters). Other devices will be signed out."}
      </p>
      <Card>
        <form onSubmit={submit} className="space-y-4" data-testid="change-password-form">
          <Field label="Current password" type="password" placeholder="Your current password" value={current}
            onChange={(e) => setCurrent(e.target.value)} data-testid="cp-current" autoComplete="current-password" />
          <Field label="New password" type="password" placeholder="At least 10 characters" value={next}
            onChange={(e) => setNext(e.target.value)} data-testid="cp-new" autoComplete="new-password" />
          <Field label="Confirm new password" type="password" placeholder="Re-enter new password" value={confirm}
            onChange={(e) => setConfirm(e.target.value)} data-testid="cp-confirm" autoComplete="new-password" />
          <Btn type="submit" className="w-full" disabled={loading} data-testid="cp-submit">
            {loading ? "Updating…" : "Update password"}
          </Btn>
        </form>
      </Card>
    </div>
  );
}
